import { PoppinsBold, PoppinsSemiBold } from '../Fonts';
import React from 'react';
import { Box } from '@chakra-ui/react';
import { ImageBox } from '../index';
import Button from '../Button';
import { Loader, RotateCw } from 'react-feather';

const ReloadableHuella = ({
	caption,
	src,
	onClick,
	reloading,
	hoverAnimation
}) => (
	<Box position="relative">
		<ImageBox
			caption={caption?.charAt(0).toUpperCase() + caption?.slice(1)}
			style={{
				width: '85px',
				height: '100px',
				cursor: reloading ? 'progress' : 'default'
			}}
			src={src}
			hoverAnimation={!reloading}
		/>
		{!!reloading ? (
			<Box
				style={{
					position: 'absolute',
					bottom: '2rem',
					right: '.5rem',
					cursor: 'progress',
					color: '#3EB944'
				}}
			>
				<Loader />
			</Box>
		) : (
			<Button
				style={{
					position: 'absolute',
					bottom: '1.5rem',
					right: '-.5rem',
					color: '#3EB944'
				}}
				onClick={onClick}
				size="sm"
				color="btn-gradient-grey"
			>
				<RotateCw />
			</Button>
		)}
	</Box>
);

const HandTitle = ({ children, ...props }) => (
	<PoppinsBold
		sx="18px"
		color="#002575"
		textAlign="center"
		width="50%"
		{...props}
	>
		{children}
	</PoppinsBold>
);

const Subtitle = ({ children, ...props }) => (
	<PoppinsSemiBold
		color="#002575"
		sx="18px"
		style={{
			textAlign: 'center',
			letterSpacing: 0,
			marginBottom: 'unset'
		}}
		{...props}
	>
		{children}
	</PoppinsSemiBold>
);

export { HandTitle, Subtitle, ReloadableHuella };
